export default __webpack_public_path__ + "static/media/icon-check-white-for-join-btn.dd69fd2a.svg";